<template>
  <div>
    <div class="title-row d-flex justify-content-between">
      <div class="text-weight-semi-bold text-size-16" v-html="title"></div>
      <div v-if="isOwner" class="task-icons d-flex">
        <font-awesome-icon
          title="Tooltip directive content"
          class="pointer"
          @click="onEdit"
          :icon="['fal', 'pencil']"
        />

        <font-awesome-icon
          title="Tooltip directive content"
          class="mx-2 pointer"
          @click="onDelete"
          :icon="['fal', 'trash-alt']"
        />
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="status text-size-14 text-weight-bold">
        <span :class="statusCss">
          {{ status }}
        </span>
      </div>
      <div v-show="isMoreVisible">
        <div @click="toggleMore(task)" :class="moreColor" class="more pointer">
          <span v-if="task.showFullDescription">
            {{ showMoreOrLess }}
            <font-awesome-icon
              title="Tooltip directive content"
              class="mx-1 pointer"
              :icon="['fas', 'angle-up']"
            />
          </span>
          <span v-else>
            {{ showMoreOrLess }}
            <font-awesome-icon
              title="Tooltip directive content"
              class="mx-1 pointer"
              :icon="['fas', 'angle-down']"
            />
          </span>
        </div>
      </div>
    </div>
    <div v-if="task.showFullDescription" class="description-wrapp">
      <div
        v-if="task.description"
        class="task-description text-weight-regular d-inline text-size-12"
        v-html="task.description"
      ></div>
    </div>
  </div>
</template>

<script>
import { extend, localize } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import de from 'vee-validate/dist/locale/de.json';
import { mapGetters } from 'vuex';

extend('required', required);

localize('de', de);

function getFirstWords(str, max) {
  const tokens = str.split(' ');
  let result = '';

  for (var i = 0; i < tokens.length; i++) {
    let checkNextWord = result + tokens[i] + ' ';
    if (checkNextWord.length > max) {
      console.log('getFirstWords:', result);
      return result;
    }
    result = checkNextWord;
  }
  return result;
}

export default {
  name: 'RenderTasksDetails',

  props: ['task'],
  data() {
    return {};
    // userName:null
  },

  computed: {
    ...mapGetters(['isOwner', 'userId']),

    moreColor() {
      return 'text-primary';
    },

    isMoreVisible() {
      if (this.task.description && this.task.description.length > 0) return true;
      if( this.task.resources && this.task.resources.length > 0) return true
      return false;
    },

    title() {
      if (this.task.resource_count > 1) {
        return this.task.title + ' (' + this.task.resource_count + 'x)';
      }
      return this.task.title;
    },

    showMoreOrLess() {
      if (this.task.showFullDescription) {
        return this.$t('tasks.less');
      }
      return this.$t('tasks.more');
    },

    assigned() {
      if (this.task.resources == null) return 0;
      return this.task.resources.length;
    },
    available() {
      return this.task.resource_count - this.assigned;
    },

    max() {
      return this.task.resource_count;
    },

    statusCss() {
      if (this.available) {
        return 'text-primary';
      }
      return 'text-accepted';
    },

    status() {
      if (this.available) {
        return (
          this.$t('tasks.open') +
          ' (' +
          this.available +
          ') ' +
          this.$t('tasks.from') +
          ' ' +
          this.max
        );
      }
      return (
        this.$t('tasks.complete') +
        ' (' +
        this.max +
        ') ' +
        this.$t('tasks.from') +
        ' ' +
        this.max
      );
    },
  },
  methods: {
    onEdit($event) {
      console.log('onEdit:', $event);
      this.$emit('edit', $event);
    },

    onDelete($event) {
      console.log('onDelete:', $event);
      this.$emit('delete', $event);
    },
    taskDescription(task) {
      if (!this.isLongDescription(task.description)) return task.description;

      if (!task.showFullDescription) {
        const result = getFirstWords(task.description, 50) + '...';
        return result;
      }
      return task.description;
    },

    toggleMore(task) {
      // if (task.showFullDescription) {
      //   task.showFullDescription = false;
      // } else {
      //   task.showFullDescription = true;
      // }
      this.$emit('toggle');
      console.log('showFullDescription:', task.showFullDescription);
    },

    needMore(task) {
      if (this.isLongDescription(task.description) && !task.showFullDescription)
        return true;
      return false;
    },
    needLess(task) {
      if (this.isLongDescription(task.description) && task.showFullDescription)
        return true;
      return false;
    },
    isLongDescription(text) {
      if (text && text.length > 50) return true;
      return false;
    },
  },

  created() {},

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  beforeDestroy() {},

  destroyed() {},
};
</script>

<style scoped lang="scss">
@import '@/styles/colors';
//$bg-color: rgba(255, 255, 255, 0.3);

.comments {
  // margin-left: 5vw;
  width: 100%;
}
</style>
